// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

interface XProductDetailsPartNumberStyles {
    wrapper?: InjectableCss;
    labelText?: TypographyPresentationProps;
    valueText?: TypographyPresentationProps;
}

export const xProductDetailsPartNumberStyles: XProductDetailsPartNumberStyles = {
    wrapper: {
        css: css`
            display: flex;
        `,
    },
    labelText: {
        variant: "h3",
        css: css`
            display: inline-block;
            margin-bottom: 0;
            padding-right: 8px;
            &:after {
                content: ":";
            }
        `,
    },
    valueText: {
        variant: "h3",
        css: css`
            margin-bottom: 0;
        `,
    },
};
